export default __webpack_public_path__ + "7df818cbe506ee635895f02b30f20a5b.png";